import { useState, useRef } from "react"
import PropTypes from "prop-types"
import { capitalize, isEmpty } from "lodash"
import { IconButton, Menu, MenuItem } from "@mui/material"
import { CloudDownload } from "@mui/icons-material"
import { connect } from "react-redux"
import { computeCSVData, downloadXlsx } from "helpers/csv"
import { Creators as NotificationCreators } from "modules/notifications/model"
import OPTooltip from "components/material/tooltip"
import { DOWNLOAD_FILENAME, ITEMS, TABLE_DOWNLOAD_DATA } from "helpers/shapes/compare-screen"
import "./styles.scss"

function CompareDownload({
  fileName,
  items,
  dispatch,
  selectedView,
  isTopicSummary,
  currentLocation,
  tableDownloadData,
  percents,
  chartDownloadData,
  isDownloadAllowed = true,
}) {
  const buttonRef = useRef()
  const [anchorEl, setAnchorEl] = useState(null)
  const [loadingChartDownload, setLoadingChartDownload] = useState(false)
  const [loadingTableDownload, setLoadingTableDownload] = useState(false)

  async function download(filename, data, downloadType) {
    const trackType = downloadType === "chart" ? "graph-timeseries" : "table"
    const success = await downloadXlsx(
      filename,
      data,
      {
        type: `compare-${currentLocation}-${selectedView}-${trackType}-download`,
        location: capitalize(currentLocation),
      },
    )
    if (!success) {
      dispatch(NotificationCreators.add("error", null, "There was a problem while generating the file. Please try again"))
    }
    setAnchorEl(null)
  }

  async function downloadChartData() {
    setLoadingChartDownload(true)
    await download(fileName.chart, computeCSVData(chartDownloadData, items, { percents }), "chart")
    setLoadingChartDownload(false)
  }

  async function downloadTableData() {
    setLoadingTableDownload(true)
    await download(fileName.table, tableDownloadData, "table")
    setLoadingTableDownload(false)
  }

  async function handleClick(e) {
    if (chartDownloadData) {
      setAnchorEl(e.currentTarget)
    } else {
      await downloadTableData()
    }
  }
  const divId = isTopicSummary ? "topic-summary-download-button" : "compare-download-button"
  return <div data-test-class={divId} id={divId}>
    <OPTooltip title="Download as XLSX">
      <IconButton
        onClick={handleClick}
        size="large"
        disabled={loadingChartDownload || loadingTableDownload || (isEmpty(tableDownloadData) && isEmpty(chartDownloadData)) || !isDownloadAllowed}
        ref={buttonRef}
      >
        <CloudDownload />
      </IconButton>
    </OPTooltip>
    <Menu
      id="compare-download-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={() => setAnchorEl(null)}
    >
      <MenuItem disabled={loadingChartDownload} onClick={downloadChartData}>Download graph to file</MenuItem>
      <MenuItem disabled={loadingTableDownload} onClick={downloadTableData}>Download compare table to file</MenuItem>
    </Menu>
  </div>
}

CompareDownload.propTypes = {
  fileName: DOWNLOAD_FILENAME,
  items: ITEMS.isRequired,
  dispatch: PropTypes.func.isRequired,
  selectedView: PropTypes.string,
  isTopicSummary: PropTypes.bool,
  currentLocation: PropTypes.string,
  tableDownloadData: TABLE_DOWNLOAD_DATA,
  chartDownloadData: PropTypes.array,
  percents: PropTypes.bool,
  isDownloadAllowed: PropTypes.bool,
}

export default connect(null, (dispatch) => ({ dispatch }))(CompareDownload)
